import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  RendererStyleFlags2
} from '@angular/core';

import {
  ActivatedRoute,
  NavigationEnd,
  Router
} from '@angular/router';

import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';

import { URL_DOCS } from 'src/app/config/config';

import {
  OwlOptions
} from 'ngx-owl-carousel-o';

import {
  MatSlideToggleChange
} from '@angular/material/slide-toggle';


declare var $: any;


type PerfilLogin =
  | 'paciente'
  | 'medico'
  | 'admin'
  | 'contact'
  | 'coordinador'
  | 'gestion'
  | 'customer'
  | 'ejecutivo'
  | 'trabajadores';

type VisualPanelState =
  | 'loading'
  | 'ready'
  | 'fallback';


@Component({
  selector: 'app-login-wrapper',
  templateUrl: './login-wrapper.component.html',
  styleUrls: ['./login-wrapper.component.css']
})
export class LoginWrapperComponent implements OnInit, OnDestroy {

  // =========================================================
  // CONFIGURACIÓN GENERAL
  // =========================================================

  public URL_DOCS = URL_DOCS;

  public perfil: PerfilLogin = 'paciente';


  // =========================================================
  // FLAGS LOGIN
  // =========================================================

  public loginPacienteFlag = true;

  public loginWorkersFlag = false;

  public showPerfilSwitch = true;


  // =========================================================
  // RESPONSIVE
  // =========================================================

  public isMobile =
    window
      .matchMedia(
        '(max-width: 575.98px)'
      )
      .matches;


  public isLarge =
    window
      .matchMedia(
        '(min-width: 992px)'
      )
      .matches;


  private mqMobile =
    window.matchMedia(
      '(max-width: 575.98px)'
    );


  private mqLarge =
    window.matchMedia(
      '(min-width: 992px)'
    );


  private mqListener: any;


  // =========================================================
  // INFORMACIÓN DEL DOMINIO
  // =========================================================

  public domainInfo: any = {};

  public domainInfoLoaded = false;

  public urlVolver = '';

  public nroMesaAyuda = '';

  public nroChat = '';

  public urlCentroAyuda = '';


  // =========================================================
  // CONTENIDO
  // =========================================================

  public tips: any[] = [];

  public colors: any = {};

  public colorsDefault: any = {};

  public certs: any[] = [];


  // =========================================================
  // ADS
  // =========================================================

  public adsCarousel: any[] = [];

  public adsTransversal: any[] = [];

  public adsPopUp: any[] = [];

  public adsCarouselFiltered: any[] = [];


  // =========================================================
  // ÍNDICES
  // =========================================================

  public currentIndexTips = 0;

  public currentIndexAds = 0;

  public currentIndexTransversal = 0;

  public currentIndexAdsPopUp = 0;

  public currentIndexCerts = 0;


  // =========================================================
  // POPUP
  // =========================================================

  public adsPopUpShown = false;


  // =========================================================
  // ERROR LOGIN
  // =========================================================

  public loginErrorData: any = {

    ok: false,

    message: '',

    url: '',

    cusName: ''

  };


  // =========================================================
  // ESTADO DEL PANEL VISUAL
  // =========================================================

  /*
   * IMPORTANTE:
   *
   * Este estado controla SOLAMENTE:
   *
   * - fondo
   * - carrusel
   * - tips visuales asociados
   *
   * NO controla el formulario.
   */
  public visualPanelState: VisualPanelState =
    'loading';


  public backgroundReady = false;

  public carouselReady = false;


  public visualFallbackTitle =
    'Contenido no disponible por ahora';


  public visualFallbackSubtitle =
    'Puedes continuar iniciando sesión con normalidad.';


  /*
   * El documento indica que este valor debe
   * definirse posteriormente en base a mediciones.
   *
   * Dejamos 10 segundos como valor técnico inicial
   * centralizado y fácil de modificar.
   */
  private readonly LOGIN_VISUAL_TIMEOUT_MS =
    20000;
/*
 * Evita que, cuando todo está cacheado,
 * el skeleton aparezca y desaparezca antes
 * de que el navegador alcance a pintarlo.
 */
private readonly MIN_SKELETON_VISIBLE_MS = 500;

private visualLoadingStartedAt = 0;

private visualRevealTimeout: any = null;

  private visualPanelTimeout: any = null;

  private visualLoadVersion = 0;

  private visualAssetsLoadStartedForVersion = -1;

  private pendingBackgroundUrl = '';


  // =========================================================
  // ROUTER
  // =========================================================

  private routerSubscription:
    Subscription | null = null;


  // =========================================================
  // TIMERS
  // =========================================================

  private tipInterval: any;

  private carouselInterval: any;

  private transversalInterval: any;

  private certInterval: any;


  // =========================================================
  // AUTOPLAY
  // =========================================================

  private readonly ADS_AUTOPLAY_MS =
    10000;


  private readonly TRANSVERSAL_AUTOPLAY_MS =
    15000;


  private readonly CERT_AUTOPLAY_MS =
    10000;


  // =========================================================
  // TEMA
  // =========================================================

  private readonly DEFAULT_PRIMARY =
    '#0E0087';


  private readonly DEFAULT_SECONDARY =
    '#9e9e9e';


  private readonly DEFAULT_THIRD =
    '#DBEAFA';


  private readonly DEFAULT_FOURTH =
    '#2f93a3';


  // =========================================================
  // BACKGROUND
  // =========================================================

  private readonly DEFAULT_LOGIN_BG =
    'assets/images/medis-login.jpg';


  // =========================================================
  // BANNER
  // =========================================================

  public bannerAnimClass = '';

  private transversalPinnedFirst = false;


  // =========================================================
  // CERTIFICACIONES
  // =========================================================

  public certOwlOptions: OwlOptions = {

    loop: true,

    mouseDrag: true,

    touchDrag: true,

    pullDrag: true,

    dots: true,

    nav: false,

    margin: 12,

    smartSpeed: 300,

    items: 1,

    responsive: {

      0: {
        items: 1
      },

      460: {
        items: 2
      }

    }

  };


  // =========================================================
  // CONSTRUCTOR
  // =========================================================

  constructor(
    private generalService: GeneralService,
    private encriptacionService: EncriptacionService,
    private router: Router,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {
  }


  // =========================================================
  // GETTERS CERTIFICACIONES
  // =========================================================

  public get showCertsDesktopRows(): boolean {

    const n =
      this.certs?.length || 0;


    return this.isLarge
      && n === 2;
  }


  public get shouldUseCertsCarousel(): boolean {

    const n =
      this.certs?.length || 0;


    if (
      this.isLarge
    ) {

      return n > 2;
    }


    return n > 1;
  }


  public get showCertsDots(): boolean {

    return this.shouldUseCertsCarousel
      && (
        this.certs?.length
        || 0
      ) > 1;
  }


  // =========================================================
  // LOGOS
  // =========================================================

  public get mainLogoUrl(): string {

    const defaultLogo =
      this.domainInfo
        ?.cus_url_image_web_default;


    return defaultLogo
      || 'assets/images/logo-almamedis.png';
  }


  public get showSecondaryLogo(): boolean {

    const customerLogo =
      this.domainInfo
        ?.cus_url_image_web;


    const cusId =
      Number(
        this.domainInfo
          ?.cus_id
      );


    const cusIdDefault =
      Number(
        this.domainInfo
          ?.cus_id_default
      );


    return !!customerLogo
      && cusId !== cusIdDefault;
  }


  public get secondaryLogoUrl(): string {

    return this.domainInfo
      ?.cus_url_image_web
      || '';
  }


  // =========================================================
  // LIFECYCLE
  // =========================================================

  ngOnInit(): void {

    /*
     * El formulario se renderiza inmediatamente.
     *
     * Únicamente ponemos el PANEL VISUAL
     * en estado loading.
     */
    this.setPerfilFromRouteData();

    this.beginVisualPanelLoadingCycle();

    this.initializeMediaQueries();

    this.initializeRouterListener();

    /*
     * La información del dominio se obtiene
     * en segundo plano.
     *
     * Esto NO bloquea el formulario.
     */
    this.observerPageInfo();

  }


  ngOnDestroy(): void {

    this.clearAutoRotation();

    this.stopCarouselAuto();

    this.stopTransversalAuto();

    this.stopCertsAuto();

    this.clearVisualPanelTimeout();


    if (
      this.routerSubscription
    ) {

      this.routerSubscription
        .unsubscribe();

      this.routerSubscription =
        null;
    }


    try {

      this.mqMobile
        .removeEventListener?.(
          'change',
          this.mqListener
        );


      this.mqLarge
        .removeEventListener?.(
          'change',
          this.mqListener
        );

    } catch {
    }

  }


  // =========================================================
  // MEDIA QUERIES
  // =========================================================

  private initializeMediaQueries(): void {

    const update = () => {

      const prevMobile =
        this.isMobile;


      const prevLarge =
        this.isLarge;


      this.isMobile =
        this.mqMobile.matches;


      this.isLarge =
        this.mqLarge.matches;


      if (
        prevMobile !== this.isMobile
        || prevLarge !== this.isLarge
      ) {

        this.initCertsCarousel();
      }

    };


    update();


    this.mqListener =
      () => update();


    this.mqMobile
      .addEventListener?.(
        'change',
        this.mqListener
      );


    this.mqLarge
      .addEventListener?.(
        'change',
        this.mqListener
      );

  }


  // =========================================================
  // ROUTER
  // =========================================================

  private initializeRouterListener(): void {

    this.routerSubscription =
      this.router.events
        .pipe(
          filter(
            (
              event
            ) =>
              event instanceof NavigationEnd
          )
        )
        .subscribe(
          () => {

            this.setPerfilFromRouteData();


            if (
              !this.isLoginRoute()
            ) {

              return;
            }


            /*
             * Cada cambio entre login paciente,
             * médico, etc. genera una carga visual
             * nueva, pero nunca un loader global.
             */
            this.beginVisualPanelLoadingCycle();


            if (
              this.domainInfoLoaded
            ) {

              this.filterAdsByPerfil();

              this.startVisualPanelLoad();

            }

          }
        );

  }


  // =========================================================
  // PERFIL
  // =========================================================

  private setPerfilFromRouteData(): void {

    let r:
      ActivatedRoute | null =
        this.route;


    while (
      r?.firstChild
    ) {

      r =
        r.firstChild;
    }


    const p =
      (
        r
          ?.snapshot
          ?.data
          ?.perfil
        || 'paciente'
      ) as PerfilLogin;


    this.perfil =
      p;


    this.loginPacienteFlag =
      this.perfil === 'paciente';


    this.loginWorkersFlag =
      this.perfil !== 'paciente';


    this.showPerfilSwitch =
      this.perfil === 'paciente'
      || this.perfil === 'medico';


    this.filterAdsByPerfil();

  }


  public cambiarPerfil(
    perfil:
      'paciente'
      | 'medico'
  ): void {

    if (
      perfil === this.perfil
    ) {

      return;
    }


    /*
     * Visualmente volvemos inmediatamente
     * al skeleton.
     *
     * El formulario NO queda bloqueado
     * por PageLoaderService.
     */
    this.visualPanelState =
      'loading';


    this.stopCarouselAuto();


    this.router.navigateByUrl(
      perfil === 'paciente'
        ? '/login'
        : '/login-doctor'
    );

  }


  public onPerfilSwitchChange(ev: Event): void {

  const target = ev.target as HTMLInputElement;

  const checked = target.checked;

  this.cambiarPerfil(
    checked
      ? 'medico'
      : 'paciente'
  );
}


  public onPerfilMatToggleChange(
    ev: MatSlideToggleChange
  ): void {

    this.cambiarPerfil(
      ev.checked
        ? 'medico'
        : 'paciente'
    );

  }


  // =========================================================
  // DOMAIN INFO
  // =========================================================

  public async observerPageInfo():
    Promise<void> {

    this.domainInfoLoaded =
      false;


    const maxAttempts =
      30;


    let attempts =
      0;


    try {

      while (
        attempts < maxAttempts
      ) {

        attempts++;


        let info: any =
          null;


        try {

          info =
            this.encriptacionService
              .getPageInfo();

        } catch {

          await this.generalService
            .sleep(
              300
            );

          continue;
        }


        if (
          !this.isDomainInfoReady(
            info
          )
        ) {

          await this.generalService
            .sleep(
              300
            );

          continue;
        }


        /*
         * Configuración obtenida.
         *
         * Esto puede ocurrir varios segundos
         * después de que el formulario ya está
         * disponible.
         */
        this.domainInfo = {
          ...info
        };


        this.domainInfoLoaded =
          true;


        this.cargarInfoDomainEnPantalla();


        /*
         * Cargamos imágenes del panel visual
         * EN PARALELO.
         */
        this.startVisualPanelLoad();


        return;

      }


      console.warn(
        'No se pudo cargar domainInfo completo.'
      );


      this.domainInfo = {};

      this.domainInfoLoaded =
        false;


      /*
       * Si todavía estamos en loading,
       * mostramos inmediatamente fallback.
       */
      if (
        this.visualPanelState
        === 'loading'
      ) {

        this.setVisualPanelFallback(
          'domain-info'
        );

      }


    } catch (error) {

      console.error(
        'Error cargando infoDomain:',
        error
      );


      this.domainInfo = {};

      this.domainInfoLoaded =
        false;


      this.setVisualPanelFallback(
        'domain-info-error'
      );

    }

  }


  private isDomainInfoReady(
    info: any
  ): boolean {

    return !!(
      info
      && info.cus_id
      && info.coloresDefault
      && Array.isArray(
        info.backgroundImgDefault
      )
    );
  }


  private cargarInfoDomainEnPantalla():
    void {

    this.urlVolver =
      this.domainInfo
        ?.link_volver_sitio
      || '';


    this.nroMesaAyuda =
      this.domainInfo
        ?.cus_url_phone
      || '';


    this.nroChat =
      this.domainInfo
        ?.cus_url_wsp
      || '';


    this.urlCentroAyuda =
      this.domainInfo
        ?.link_centro_ayuda
      || '';


    this.tips = [
      ...(
        this.domainInfo
          ?.tips
        || []
      )
    ];


    this.colors = {
      ...(
        this.domainInfo
          ?.colores
        || {}
      )
    };


    this.colorsDefault = {
      ...(
        this.domainInfo
          ?.coloresDefault
        || {}
      )
    };


    this.certs = [
      ...(
        this.domainInfo
          ?.cert
        || []
      )
    ];


    this.adsCarousel = [
      ...(
        this.domainInfo
          ?.ads
        || []
      )
    ];


    this.adsTransversal =
      this.sortAdsTransversal(
        [
          ...(
            this.domainInfo
              ?.adsTransversal
            || []
          )
        ]
      );


    this.adsPopUp = [
      ...(
        this.domainInfo
          ?.adsPopup
        || []
      )
    ];


    this.transversalPinnedFirst =
      false;


    this.applyThemeFromDomain();

    this.filterAdsByPerfil();

    this.initTransversalBanner();

    this.initCertsCarousel();


    this.clearAutoRotation();


    if (
      this.tips?.length > 1
    ) {

      this.startAutoRotation();
    }


    /*
     * IMPORTANTE:
     *
     * No abrimos automáticamente adsPopUp
     * durante la carga inicial del login.
     *
     * Un modal impediría la interacción con
     * RUT/contraseña y volveríamos a incumplir
     * el requerimiento de login sin bloqueo.
     */

  }


  // =========================================================
  // PANEL VISUAL
  // =========================================================

  private beginVisualPanelLoadingCycle(): void {

  this.visualLoadVersion++;

  this.visualAssetsLoadStartedForVersion = -1;

  this.backgroundReady = false;
  this.carouselReady = false;

  this.pendingBackgroundUrl = '';

  this.visualPanelState = 'loading';

  /*
   * Guardamos el momento exacto en que
   * comienza el skeleton.
   */
  this.visualLoadingStartedAt =
    Date.now();

  this.stopCarouselAuto();

  this.clearVisualPanelTimeout();

  if (this.visualRevealTimeout) {

    clearTimeout(
      this.visualRevealTimeout
    );

    this.visualRevealTimeout = null;
  }

  const currentVersion =
    this.visualLoadVersion;

  this.visualPanelTimeout =
    setTimeout(
      () => {

        if (
          currentVersion
          !== this.visualLoadVersion
        ) {
          return;
        }

        if (
          this.visualPanelState
          !== 'loading'
        ) {
          return;
        }

        this.setVisualPanelFallback(
          'timeout'
        );

      },
      this.LOGIN_VISUAL_TIMEOUT_MS
    );
}


  private clearVisualPanelTimeout():
    void {

    if (
      this.visualPanelTimeout
    ) {

      clearTimeout(
        this.visualPanelTimeout
      );


      this.visualPanelTimeout =
        null;
    }

  }


  private startVisualPanelLoad(): void {

  if (
    !this.domainInfoLoaded
  ) {
    return;
  }


  if (
    this.visualPanelState !== 'loading'
  ) {
    return;
  }


  const currentVersion =
    this.visualLoadVersion;


  if (
    this.visualAssetsLoadStartedForVersion
    === currentVersion
  ) {
    return;
  }


  this.visualAssetsLoadStartedForVersion =
    currentVersion;


  const backgroundUrl =
    this.getCurrentLoginBackgroundUrl();


  const currentAd =
    this.adsCarouselFiltered?.[0];


  const carouselImageUrl =
    currentAd
      ? this.getAdImageUrl(currentAd)
      : '';


  this.pendingBackgroundUrl =
    backgroundUrl;


  /*
   * =========================================
   * BACKGROUND
   * =========================================
   *
   * Se carga independientemente del carrusel.
   */
  if (backgroundUrl) {

    this.preloadImage(
      backgroundUrl
    )
      .then(
        (success: boolean) => {

          if (
            currentVersion
            !== this.visualLoadVersion
          ) {
            return;
          }


          if (
            this.visualPanelState
            !== 'loading'
          ) {
            return;
          }


          if (success) {

            this.backgroundReady = true;

          } else {

            console.warn(
              '[LOGIN] Error cargando background:',
              backgroundUrl
            );

            /*
             * No bloqueamos el resto de la pantalla.
             */
            this.backgroundReady = true;
          }


          this.tryRevealVisualPanel(
            currentVersion
          );
        }
      );

  } else {

    /*
     * Sin background configurado:
     * usamos igualmente el panel neutro.
     */
    this.backgroundReady = true;
  }


  /*
   * =========================================
   * CARRUSEL
   * =========================================
   */

  if (carouselImageUrl) {

    this.preloadImage(
      carouselImageUrl
    )
      .then(
        (success: boolean) => {

          if (
            currentVersion
            !== this.visualLoadVersion
          ) {
            return;
          }


          if (
            this.visualPanelState
            !== 'loading'
          ) {
            return;
          }


          if (success) {

            this.carouselReady = true;

          } else {

            console.warn(
              '[LOGIN] Error cargando carrusel:',
              carouselImageUrl
            );

            /*
             * No dejamos al login pegado eternamente.
             */
            this.carouselReady = true;
          }


          this.tryRevealVisualPanel(
            currentVersion
          );
        }
      );

  } else {

    this.carouselReady = true;
    this.tryRevealVisualPanel(
      currentVersion
    );
  }

}


private tryRevealVisualPanel(
  version: number
): void {

  if (
    version !== this.visualLoadVersion
  ) {
    return;
  }


  if (
    this.visualPanelState !== 'loading'
  ) {
    return;
  }


  /*
   * Ambos procesos ya terminaron.
   *
   * Ojo:
   * carouselReady también puede significar
   * "no hay carrusel configurado".
   */
  if (
    !this.backgroundReady
    || !this.carouselReady
  ) {
    return;
  }


  const elapsed =
    Date.now()
    - this.visualLoadingStartedAt;


  const remaining =
    Math.max(
      0,
      this.MIN_SKELETON_VISIBLE_MS
      - elapsed
    );


  if (
    this.visualRevealTimeout
  ) {

    clearTimeout(
      this.visualRevealTimeout
    );

    this.visualRevealTimeout = null;
  }


  this.visualRevealTimeout =
    setTimeout(
      () => {

        if (
          version !== this.visualLoadVersion
        ) {
          return;
        }


        if (
          this.visualPanelState !== 'loading'
        ) {
          return;
        }


        /*
         * Si existe background válido,
         * lo aplicamos.
         */
        if (
          this.pendingBackgroundUrl
        ) {

          this.applyLoginBackgroundUrl(
            this.pendingBackgroundUrl
          );
        }


        this.visualPanelState =
          'ready';


        this.clearVisualPanelTimeout();


        /*
         * Solo inicializamos autoplay
         * cuando realmente existen anuncios.
         */
        if (
          this.adsCarouselFiltered?.length
        ) {

          this.initCarouselFiltered();

          this.preloadRemainingCarouselImages();
        }

      },
      remaining
    );

}


  private setVisualPanelFallback(
    reason: string
  ): void {

    if (
      this.visualPanelState
        === 'fallback'
    ) {

      return;
    }


    console.warn(
      '[LoginVisualPanel] fallback:',
      reason
    );


    this.visualPanelState =
      'fallback';


    this.backgroundReady =
      false;


    this.carouselReady =
      false;


    this.stopCarouselAuto();

    this.clearVisualPanelTimeout();

  }


  public onActiveCarouselImageError():
    void {

    /*
     * Si una imagen real falla después
     * de haber sido revelada, el panel
     * completo pasa a fallback.
     */
    this.setVisualPanelFallback(
      'active-carousel-image-error'
    );

  }


  private preloadImage(
    url: string
  ): Promise<boolean> {

    return new Promise(
      (
        resolve
      ) => {

        if (
          !url
        ) {

          resolve(
            false
          );

          return;
        }


        const img =
          new Image();


        img.onload =
          () => resolve(
            true
          );


        img.onerror =
          () => resolve(
            false
          );


        img.src =
          url;

      }
    );

  }


  private preloadRemainingCarouselImages():
    void {

    const remainingAds =
      this.adsCarouselFiltered
        .slice(
          1
        );


    remainingAds
      .forEach(
        (
          ad: any
        ) => {

          const url =
            this.getAdImageUrl(
              ad
            );


          if (
            url
          ) {

            /*
             * No esperamos esta promesa.
             *
             * Es precarga no crítica.
             */
            this.preloadImage(
              url
            );

          }

        }
      );

  }


  // =========================================================
  // BACKGROUND
  // =========================================================

  private getCurrentLoginBackgroundUrl():
    string {

    const profile =
      this.getProfileTypeForBackgrounds();


    const customList =
      Array.isArray(
        this.domainInfo
          ?.backgroundImg
      )
        ? this.domainInfo
            .backgroundImg
        : [];


    const defaultList =
      Array.isArray(
        this.domainInfo
          ?.backgroundImgDefault
      )
        ? this.domainInfo
            .backgroundImgDefault
        : [];


   const pick = (
  list: any[],
  p: string
) => {

  return list.find(
    (x: any) => {

      const type =
        String(
          x?.profile_type
          || ''
        )
          .trim()
          .toLowerCase();

      const enabled =
        this.normalizeBoolean(
          x?.is_enabled
        );

      const path =
        String(
          x?.bg_path
          || ''
        )
          .trim();

      return (
        enabled
        &&
        type === p
        &&
        !!path
      );

    }
  ) || null;
};


    const custom =
      pick(
        customList,
        profile
      );


    const def =
      pick(
        defaultList,
        profile
      );


    const defPaciente =
      pick(
        defaultList,
        'paciente'
      );


    return (
      this.buildDocumentUrl(
        custom?.bg_path
      )
      || this.buildDocumentUrl(
        def?.bg_path
      )
      || this.buildDocumentUrl(
        defPaciente?.bg_path
      )
      || this.DEFAULT_LOGIN_BG
    );

  }


  private applyLoginBackgroundUrl(
    finalUrl: string
  ): void {

    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--login-bg-url',
      `url("${finalUrl}")`,
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );

  }


  private getProfileTypeForBackgrounds():
    string {

    if (
      this.perfil === 'paciente'
    ) {

      return 'paciente';
    }


    if (
      this.perfil === 'medico'
    ) {

      return 'doctor';
    }


    return 'trabajadores';
  }


  // =========================================================
  // URL HELPERS
  // =========================================================

  private buildDocumentUrl(
    path: any
  ): string {

    const p =
      String(
        path
        || ''
      )
        .trim();


    if (
      !p
    ) {

      return '';
    }


    if (
      /^https?:\/\//i.test(
        p
      )
    ) {

      return p;
    }


    return `${this.URL_DOCS}${p}`;
  }


  public getAdImageUrl(
    ad: any
  ): string {

    return this.buildDocumentUrl(
      ad?.image_url
    );
  }


  // =========================================================
  // LINKS AYUDA
  // =========================================================

  public goCentroAyuda():
    void {

    if (
      !this.urlCentroAyuda
    ) {

      return;
    }


    window.open(
      this.urlCentroAyuda,
      '_blank'
    );

  }


  public getTelLink(
    phone: string
  ): string {

    if (
      !phone
    ) {

      return '';
    }


    return `tel:${
      phone
        .toString()
        .replace(
          /[^\d+]/g,
          ''
        )
    }`;

  }


  public getWhatsappLink(
    phone: string
  ): string {

    if (
      !phone
    ) {

      return '';
    }


    const digits =
      phone
        .toString()
        .replace(
          /\D/g,
          ''
        );


    return digits
      ? `https://wa.me/${digits}`
      : '';

  }


  // =========================================================
  // THEME
  // =========================================================

  private isValidHexColor(
    value: string
  ): boolean {

    if (
      !value
    ) {

      return false;
    }


    const v =
      value.trim();


    return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/
      .test(
        v
      );

  }


  private hexToRgba(
    hex: string,
    alpha = 0.18
  ): string {

    const h =
      (
        hex
        || ''
      )
        .replace(
          '#',
          ''
        )
        .trim();


    const full =
      h.length === 3

        ? h
            .split('')
            .map(
              (
                c
              ) =>
                c + c
            )
            .join('')

        : h;


    if (
      full.length !== 6
    ) {

      return `rgba(14, 0, 135, ${alpha})`;
    }


    const r =
      parseInt(
        full.substring(
          0,
          2
        ),
        16
      );


    const g =
      parseInt(
        full.substring(
          2,
          4
        ),
        16
      );


    const b =
      parseInt(
        full.substring(
          4,
          6
        ),
        16
      );


    return `rgba(${r}, ${g}, ${b}, ${alpha})`;

  }


  private applyThemeFromDomain():
    void {

    const colores =
      this.domainInfo
        ?.colores
      || {};


    const coloresDefault =
      this.domainInfo
        ?.coloresDefault
      || {};


    const isActive =
      colores?.is_active
        === true;


    const pickSponsorOrDefault =
      (
        sponsorValue: any,
        defaultValue: any,
        hardcodedFallback: string
      ): string => {

        const sponsor =
          (
            sponsorValue
            ?? ''
          )
            .toString()
            .trim();


        const def =
          (
            defaultValue
            ?? ''
          )
            .toString()
            .trim();


        if (
          isActive
          && sponsor
          && this.isValidHexColor(
            sponsor
          )
        ) {

          return sponsor;
        }


        if (
          def
          && this.isValidHexColor(
            def
          )
        ) {

          return def;
        }


        return hardcodedFallback;

      };


    const primary =
      pickSponsorOrDefault(

        colores?.color_primary,

        coloresDefault
          ?.color_primary,

        this.DEFAULT_PRIMARY
      );


    const secondary =
      pickSponsorOrDefault(

        colores?.color_secundary,

        coloresDefault
          ?.color_secundary,

        this.DEFAULT_SECONDARY
      );


    const third =
      pickSponsorOrDefault(

        colores?.color_third,

        coloresDefault
          ?.color_third,

        this.DEFAULT_THIRD
      );


    const fourth =
      pickSponsorOrDefault(

        colores?.color_fourth,

        coloresDefault
          ?.color_fourth,

        this.DEFAULT_FOURTH
      );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-primary',
      primary,
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-primary-focus-shadow',
      this.hexToRgba(
        primary,
        0.18
      ),
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-secondary',
      secondary,
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-third',
      third,
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );


    this.renderer.setStyle(
      this.elRef.nativeElement,
      '--am-fourth',
      fourth,
      RendererStyleFlags2.DashCase
      | RendererStyleFlags2.Important
    );

  }


  // =========================================================
  // ADS CARRUSEL
  // =========================================================

  private getProfileTypeForAds():
    string {

    return (
      this.perfil
      || 'paciente'
    )
      .toLowerCase();

  }


 private filterAdsByPerfil(): void {

  const perfilActual =
    this.getProfileTypeForAds();

  const src =
    Array.isArray(
      this.adsCarousel
    )
      ? [...this.adsCarousel]
      : [];

  const alias:
    Record<string, string[]> = {

      paciente: [
        'paciente'
      ],

      medico: [
        'medico',
        'doctor'
      ],

      admin: [
        'admin'
      ],

      contact: [
        'contact'
      ],

      coordinador: [
        'coordinador'
      ],

      gestion: [
        'gestion'
      ],

      customer: [
        'customer'
      ],

      trabajadores: [
        'trabajadores',
        'worker',
        'workers'
      ],

      ejecutivo: [
        'ejecutivo',
        'ejecutivos'
      ]

    };

  const acceptedProfiles =
    new Set(
      alias[perfilActual]
      || [perfilActual]
    );

  const perfilNoGlobal =
    src
      .filter(
        (ad: any) => {

          const type =
            this.getAdProfile(
              ad
            );

          return (
            acceptedProfiles.has(type)
            &&
            !this.normalizeBoolean(
              ad?.is_global
            )
          );
        }
      )
      .sort(
        (a: any, b: any) =>
          this.sortByPriority(
            a,
            b
          )
      );

  const allNoGlobal =
    src
      .filter(
        (ad: any) => {

          return (
            this.getAdProfile(ad) === 'all'
            &&
            !this.normalizeBoolean(
              ad?.is_global
            )
          );
        }
      )
      .sort(
        (a: any, b: any) =>
          this.sortByPriority(
            a,
            b
          )
      );

  const perfilGlobal =
    src
      .filter(
        (ad: any) => {

          const type =
            this.getAdProfile(
              ad
            );

          return (
            acceptedProfiles.has(type)
            &&
            this.normalizeBoolean(
              ad?.is_global
            )
          );
        }
      )
      .sort(
        (a: any, b: any) =>
          this.sortByPriority(
            a,
            b
          )
      );

  const allGlobal =
    src
      .filter(
        (ad: any) => {

          return (
            this.getAdProfile(ad) === 'all'
            &&
            this.normalizeBoolean(
              ad?.is_global
            )
          );
        }
      )
      .sort(
        (a: any, b: any) =>
          this.sortByPriority(
            a,
            b
          )
      );

  const ordered = [

    ...perfilNoGlobal,

    ...allNoGlobal,

    ...perfilGlobal,

    ...allGlobal

  ];

  const seen =
    new Set<string>();

  this.adsCarouselFiltered =
    ordered
      .filter(
        (ad: any) => {

          const key =
            String(
              ad?.ad_id
              ?? ad?.id
              ?? `${ad?.image_url}|${ad?.title}`
            );

          if (
            seen.has(
              key
            )
          ) {
            return false;
          }

          seen.add(
            key
          );

          return true;
        }
      )
      .slice(
        0,
        5
      );

  this.currentIndexAds = 0;

  this.stopCarouselAuto();


  /*
   * Temporal para validar los datos.
   * Después lo puedes eliminar.
   */
 
}


  private getAdProfile(
    ad: any
  ): string {

    return String(
      ad?.profile_type
      ?? ad?.perfil
      ?? ad?.profile
      ?? 'all'
    )
      .trim()
      .toLowerCase();

  }


  private toPriorityCarousel(
    value: any
  ): number {

    const n =
      Number(
        value
      );


    return Number.isFinite(
      n
    )
      ? n
      : 999999;

  }


  private sortByPriority(
    a: any,
    b: any
  ): number {

    const pa =
      this.toPriorityCarousel(
        a?.priority
        ?? a?.ad_priority
        ?? a?.order_priority
      );


    const pb =
      this.toPriorityCarousel(
        b?.priority
        ?? b?.ad_priority
        ?? b?.order_priority
      );


    return pa - pb;

  }


  private initCarouselFiltered():
    void {

    this.stopCarouselAuto();


    if (
      !this.adsCarouselFiltered
        ?.length
    ) {

      return;
    }


    if (
      this.adsCarouselFiltered
        .length > 1
    ) {

      this.startCarouselAuto();
    }

  }


  private startCarouselAuto():
    void {

    this.stopCarouselAuto();


    this.carouselInterval =
      setInterval(
        () =>
          this.next(
            false
          ),
        this.ADS_AUTOPLAY_MS
      );

  }


  private stopCarouselAuto():
    void {

    if (
      this.carouselInterval
    ) {

      clearInterval(
        this.carouselInterval
      );


      this.carouselInterval =
        null;
    }

  }


  public resetAuto():
    void {

    if (
      !this.adsCarouselFiltered
      || this.adsCarouselFiltered
          .length <= 1
    ) {

      return;
    }


    this.startCarouselAuto();

  }


  public next(
    resetTimer = true
  ): void {

    if (
      this.visualPanelState
        !== 'ready'
    ) {

      return;
    }


    if (
      !this.adsCarouselFiltered
        ?.length
    ) {

      return;
    }


    this.currentIndexAds =
      (
        this.currentIndexAds
        + 1
      )
      %
      this.adsCarouselFiltered
        .length;


    if (
      resetTimer
    ) {

      this.resetAuto();
    }

  }


  public prev():
    void {

    if (
      this.visualPanelState
        !== 'ready'
    ) {

      return;
    }


    if (
      !this.adsCarouselFiltered
        ?.length
    ) {

      return;
    }


    this.currentIndexAds =
      (
        this.currentIndexAds
        - 1
        + this.adsCarouselFiltered
            .length
      )
      %
      this.adsCarouselFiltered
        .length;


    this.resetAuto();

  }


  public goTo(
    index: number
  ): void {

    if (
      this.visualPanelState
        !== 'ready'
    ) {

      return;
    }


    this.currentIndexAds =
      index;


    this.resetAuto();

  }


  public openAd(
    ad: any
  ): void {

    const url =
      this.normalizeUrl(
        ad?.link_url
      );


    const target =
      ad?.link_target
      || '_self';


    if (
      !url
    ) {

      return;
    }


    window.open(
      url,
      target
    );

  }


  public normalizeUrl(
    url: string
  ): string {

    if (
      !url
    ) {

      return '';
    }


    const cleaned =
      url
        .toString()
        .trim();


    if (
      !/^https?:\/\//i.test(
        cleaned
      )
    ) {

      return `https://${cleaned}`;
    }


    return cleaned;

  }


  // =========================================================
  // TIPS
  // =========================================================

  public startAutoRotation():
    void {

    this.clearAutoRotation();


    this.tipInterval =
      setInterval(
        () =>
          this.nextTip(),
        10000
      );

  }


  public clearAutoRotation():
    void {

    if (
      this.tipInterval
    ) {

      clearInterval(
        this.tipInterval
      );


      this.tipInterval =
        null;
    }

  }


  public nextTip():
    void {

    if (
      !this.tips?.length
    ) {

      return;
    }


    this.currentIndexTips =
      (
        this.currentIndexTips
        + 1
      )
      %
      this.tips.length;

  }


  public goToTip(
    index: number
  ): void {

    this.currentIndexTips =
      index;


    this.clearAutoRotation();


    if (
      this.tips?.length > 1
    ) {

      this.startAutoRotation();
    }

  }


  // =========================================================
  // CERTIFICACIONES
  // =========================================================

  private initCertsCarousel():
    void {

    const n =
      this.certs?.length || 0;


    if (
      !this.shouldUseCertsCarousel
      || !n
    ) {

      this.stopCertsAuto();

      this.currentIndexCerts =
        0;

      return;
    }


    if (
      this.currentIndexCerts
        >= n
    ) {

      this.currentIndexCerts =
        0;
    }


    if (
      n > 1
    ) {

      this.startCertsAuto();

    } else {

      this.stopCertsAuto();

    }

  }


  private startCertsAuto():
    void {

    this.stopCertsAuto();


    this.certInterval =
      setInterval(
        () =>
          this.nextCert(),
        this.CERT_AUTOPLAY_MS
      );

  }


  private stopCertsAuto():
    void {

    if (
      this.certInterval
    ) {

      clearInterval(
        this.certInterval
      );


      this.certInterval =
        null;
    }

  }


  private nextCert():
    void {

    const n =
      this.certs?.length || 0;


    if (
      !n
    ) {

      return;
    }


    this.currentIndexCerts =
      (
        this.currentIndexCerts
        + 1
      )
      % n;

  }


  public goToCert(
    index: number
  ): void {

    const n =
      this.certs?.length || 0;


    if (
      !n
    ) {

      return;
    }


    this.currentIndexCerts =
      index;


    if (
      this.shouldUseCertsCarousel
      && n > 1
    ) {

      this.startCertsAuto();
    }

  }


  // =========================================================
  // TRANSVERSAL
  // =========================================================

  public isCurrentTransversalGlobal():
    boolean {

    const ad =
      this.adsTransversal
        ?.[
          this.currentIndexTransversal
        ];


    return ad?.is_global
      === true;
  }


  public initTransversalBanner():
    void {

    this.stopTransversalAuto();


    if (
      !this.adsTransversal
        ?.length
    ) {

      this.currentIndexTransversal =
        0;

      return;
    }


    if (
      !this.transversalPinnedFirst
    ) {

      const idxGlobal =
        this.findFirstGlobalTransversalIndex();


      this.currentIndexTransversal =
        idxGlobal >= 0
          ? idxGlobal
          : 0;


      this.transversalPinnedFirst =
        true;
    }


    if (
      this.currentIndexTransversal
        >= this.adsTransversal.length
    ) {

      this.currentIndexTransversal =
        0;
    }


    if (
      this.adsTransversal
        .length > 1
    ) {

      this.startTransversalAuto();
    }

  }


  private startTransversalAuto():
    void {

    this.stopTransversalAuto();


    this.transversalInterval =
      setInterval(
        () =>
          this.nextTransversal(
            false
          ),
        this.TRANSVERSAL_AUTOPLAY_MS
      );

  }


  private stopTransversalAuto():
    void {

    if (
      this.transversalInterval
    ) {

      clearInterval(
        this.transversalInterval
      );


      this.transversalInterval =
        null;
    }

  }


  private resetTransversalAuto():
    void {

    if (
      !this.adsTransversal
      || this.adsTransversal
          .length <= 1
    ) {

      return;
    }


    this.startTransversalAuto();

  }


  private animateBannerSwap(
    doSwap:
      () => void
  ): void {

    this.bannerAnimClass =
      'banner-out-up';


    setTimeout(
      () => {

        doSwap();


        this.bannerAnimClass =
          'banner-in-down';


        setTimeout(
          () => {

            this.bannerAnimClass =
              '';

          },
          280
        );

      },
      220
    );

  }


  public nextTransversal(
    resetTimer = true
  ): void {

    if (
      !this.adsTransversal
        ?.length
    ) {

      return;
    }


    this.animateBannerSwap(
      () => {

        this.currentIndexTransversal =
          (
            this.currentIndexTransversal
            + 1
          )
          %
          this.adsTransversal
            .length;

      }
    );


    if (
      resetTimer
    ) {

      this.resetTransversalAuto();
    }

  }


  public goToTransversal(
    index: number
  ): void {

    if (
      !this.adsTransversal
        ?.length
    ) {

      return;
    }


    this.animateBannerSwap(
      () => {

        this.currentIndexTransversal =
          index;

      }
    );


    this.resetTransversalAuto();

  }


  public closeTransversalBanner():
    void {

    if (
      !this.adsTransversal
        ?.length
    ) {

      return;
    }


    if (
      this.adsTransversal
        .length > 1
    ) {

      this.animateBannerSwap(
        () => {

          this.adsTransversal
            .splice(
              this.currentIndexTransversal,
              1
            );


          if (
            this.currentIndexTransversal
              >= this.adsTransversal.length
          ) {

            this.currentIndexTransversal =
              0;
          }

        }
      );


      this.resetTransversalAuto();

      return;
    }


    this.stopTransversalAuto();


    this.animateBannerSwap(
      () => {

        this.adsTransversal = [];

        this.currentIndexTransversal =
          0;

      }
    );

  }


  // =========================================================
  // TRANSVERSAL HELPERS
  // =========================================================

  private isTransversalGlobalByCustomer(
    ad: any
  ): boolean {

    const v =
      ad?.b2b_id_customer;


    return v === null
      || v === undefined
      || (
        typeof v === 'string'
        && v.trim() === ''
      );

  }


  private findFirstGlobalTransversalIndex():
    number {

    const list =
      Array.isArray(
        this.adsTransversal
      )
        ? this.adsTransversal
        : [];


    return list.findIndex(
      (
        ad: any
      ) =>
        this.isTransversalGlobalByCustomer(
          ad
        )
    );

  }


  private isGlobalCustomer(
    value: any
  ): boolean {

    return value === null
      || value === undefined
      || (
        typeof value === 'string'
        && value.trim() === ''
      );

  }


  private toPriority(
    value: any
  ): number {

    const n =
      Number(
        value
      );


    return Number.isFinite(
      n
    )
      ? n
      : 999999;

  }


  private sortAdsTransversal(
    list: any[]
  ): any[] {

    const arr =
      Array.isArray(
        list
      )
        ? [
            ...list
          ]
        : [];


    arr.sort(
      (
        a: any,
        b: any
      ) => {

        const aGlobal =
          this.isGlobalCustomer(
            a?.b2b_id_customer
          );


        const bGlobal =
          this.isGlobalCustomer(
            b?.b2b_id_customer
          );


        if (
          aGlobal !== bGlobal
        ) {

          return aGlobal
            ? -1
            : 1;
        }


        const pa =
          this.toPriority(
            a?.priority
          );


        const pb =
          this.toPriority(
            b?.priority
          );


        if (
          pa !== pb
        ) {

          return pa - pb;
        }


        return 0;

      }
    );


    return arr;

  }


  // =========================================================
  // POPUP
  // =========================================================

  private openAdsPopUpModal():
    void {

    document.body.classList
      .add(
        'ads-popup-open'
      );


    $('#adsPopUpModal')
      .modal(
        'show'
      );

  }


  public closeAdsPopUpModal():
    void {

    document.body.classList
      .remove(
        'ads-popup-open'
      );


    $('#adsPopUpModal')
      .modal(
        'hide'
      );

  }


  public nextAdsPopUp():
    void {

    if (
      !this.adsPopUp?.length
    ) {

      return;
    }


    this.currentIndexAdsPopUp =
      (
        this.currentIndexAdsPopUp
        + 1
      )
      %
      this.adsPopUp.length;

  }


  public prevAdsPopUp():
    void {

    if (
      !this.adsPopUp?.length
    ) {

      return;
    }


    this.currentIndexAdsPopUp =
      (
        this.currentIndexAdsPopUp
        - 1
        + this.adsPopUp.length
      )
      %
      this.adsPopUp.length;

  }


  public goToAdsPopUp(
    index: number
  ): void {

    if (
      !this.adsPopUp?.length
    ) {

      return;
    }


    this.currentIndexAdsPopUp =
      index;

  }


  // =========================================================
  // LOGIN ROUTE
  // =========================================================

  private isLoginRoute():
    boolean {

    const url =
      this.router.url
      || '';


    return (
      url.includes(
        '/login'
      )
      || url.includes(
        '/login-doctor'
      )
      || url.includes(
        '/login-contact'
      )
      || url.includes(
        '/login-coordinador'
      )
      || url.includes(
        '/login-cliente'
      )
      || url.includes(
        '/login-admin'
      )
      || url.includes(
        '/login-gestion'
      )
      || url.includes(
        '/login-ejecutivo'
      )
      || url.includes(
        '/login-trabajadores'
      )
    );

  }


  // =========================================================
  // LOGIN ERROR
  // =========================================================

  public onLoginError(
    error: any
  ): void {

    console.log(
      'Error recibido desde LoginComponent:',
      error
    );


    this.loginErrorData = {

      ok:
        error?.ok
        ?? false,

      message:
        error?.message
        || '',

      url:
        error?.url
        || '',

      cusName:
        error?.cusName
        || ''

    };

  }

  private normalizeBoolean(
  value: any
): boolean {

  if (value === true) {
    return true;
  }

  if (value === false) {
    return false;
  }

  if (value === 1 || value === '1') {
    return true;
  }

  if (value === 0 || value === '0') {
    return false;
  }

  const normalized =
    String(value || '')
      .trim()
      .toLowerCase();

  return normalized === 'true'
    || normalized === 'si'
    || normalized === 'sí';
}

}